import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CdkDragDrop, CdkDragEnter, CdkDragMove, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
    selector: 'pim-file-gallery',
    templateUrl: './file-gallery.component.html',
    styleUrls: ['./file-gallery.component.sass'],
    standalone: false
})
export class FileGalleryComponent {
	@ViewChild('dropListContainer') dropListContainer?: ElementRef;

	// tslint:disable-next-line:variable-name
	public _items: GalleryFile[] = [];

	@Input('fileNames')
	public get items(): GalleryFile[] {
		return this._items;
	}

	public set items(value: GalleryFile[]) {
		this._items = value.filter((file: GalleryFile) => {
			return !file.unsaved;
		}).map((file: GalleryFile) => {
			// Quick and dirty. Either all image-types or all possible document-types. Both suck. So only check for pdf
			file.type = file.url.endsWith('pdf') ? 'document' : 'image';
			return file;
		});
	}

	@Input()
	title: string = 'Dateien';

	@Input()
	thumbnailSize: number = 150;

	@Input()
	editMode: boolean = false;

	@Output()
	fileDeleted: EventEmitter<string> = new EventEmitter<string>();

	@Output()
	sorted: EventEmitter<GalleryFile[]> = new EventEmitter<GalleryFile[]>();

	dropListReceiverElement?: HTMLElement;
	dragDropInfo?: {
		dragIndex: number;
		dropIndex: number;
	};

	deleteFile(event: any, file: GalleryFile): void {
		event.preventDefault();
		event.stopPropagation();
		this.items.splice(this.items.indexOf(file), 1);
		this.fileDeleted.emit(file.url);
	}

	dragEntered(event: CdkDragEnter<number>): void {
		const drag = event.item;
		const dropList = event.container;
		const dragIndex = drag.data;
		const dropIndex = dropList.data;

		this.dragDropInfo = { dragIndex, dropIndex };

		const phContainer = dropList.element.nativeElement;
		const phElement = phContainer.querySelector('.cdk-drag-placeholder');

		if (phElement) {
			phContainer.removeChild(phElement);
			phContainer.parentElement?.insertBefore(phElement, phContainer);

			moveItemInArray(this.items, dragIndex, dropIndex);
		}
	}

	dragMoved(event: CdkDragMove<number>): void {
		if (!this.dropListContainer || !this.dragDropInfo) { return; }

		const placeholderElement =
			this.dropListContainer.nativeElement.querySelector(
				'.cdk-drag-placeholder'
			);

		const receiverElement =
			this.dragDropInfo.dragIndex > this.dragDropInfo.dropIndex
				? placeholderElement?.nextElementSibling
				: placeholderElement?.previousElementSibling;

		if (!receiverElement) {
			return;
		}

		receiverElement.style.display = 'none';
		this.dropListReceiverElement = receiverElement;
	}

	dragDropped(event: CdkDragDrop<number>): void {
		if (!this.dropListReceiverElement) {
			return;
		}

		this.dropListReceiverElement.style.removeProperty('display');
		this.dropListReceiverElement = undefined;
		this.dragDropInfo = undefined;

		this.applyOrder(this._items);
		this.sorted.emit(this._items);
	}

	private applyOrder(input: GalleryFile[]): void {
		for (let i = 0; i < input.length; i++) {
			const element = input[i];
			element.order = i + 1;
		}
	}

}

export interface GalleryFile {
	url: string;
	order: number;
	unsaved?: boolean | undefined;
	type?: 'document' | 'image';
}
